export const siteInfo = {
  name: '麻花视频',
  tagline: '海量影视 · 免费畅享',
  slogan: '不缓冲 · 不收费 · 不将就',
  description: '麻花视频是一个专注提供高清电视剧与电影免费在线观看的平台，每日更新最新剧集资源，涵盖都市情感、古装玄幻、悬疑推理、青春校园等全类型内容，采用高速CDN加速技术确保播放不缓冲、不卡顿，无需注册会员即可畅享流畅观影体验。',
  stats: [
    { label: '每日更新', value: '50+', suffix: '部' },
    { label: '高清画质', value: '1080P', suffix: '' },
    { label: '全类型覆盖', value: '12', suffix: '大类' },
  ],
};

export const aboutData = {
  title: '平台介绍',
  content: [
    '麻花视频成立于2020年，致力于为广大追剧爱好者打造一站式免费观影平台。平台汇聚了来自各大版权方的正版授权影视资源，涵盖国产剧、韩剧、美剧、日剧、泰剧等多元内容，无论你偏爱古装权谋、现代都市还是青春甜宠，都能在这里找到心仪好剧。',
    '我们采用业界领先的视频编码与CDN分发技术，支持多线路智能切换，即使在网络波动环境下也能保持流畅播放。平台每日同步更新最新剧集，热门剧集上线24小时内即可观看，让你不再错过任何精彩瞬间。',
  ],
};

export const featuresData = [
  {
    icon: 'ri-movie-2-line',
    title: '海量片库',
    desc: '汇聚10万+影视资源，覆盖国产剧、韩剧、美剧、日剧等全品类，每日持续更新最新内容。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '高清流畅',
    desc: '支持1080P超清画质，多线路智能切换，CDN加速保障不缓冲不卡顿的极致观影体验。',
  },
  {
    icon: 'ri-vip-crown-line',
    title: '完全免费',
    desc: '无需注册、无需会员、无需付费即可畅享全部内容，真正做到零门槛追剧观影。',
  },
];

export const cardsData = [
  {
    title: '都市情感剧场',
    desc: '精选年度热播都市情感大剧，聚焦当代都市人的爱恨情仇与职场风云，暖心治愈每一刻。',
    tag: '热门',
    tagColor: 'primary',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20drama%20scene%20with%20young%20couple%20in%20city%20street%20at%20sunset%2C%20cinematic%20lighting%2C%20warm%20golden%20tones%2C%20soft%20bokeh%20background%2C%20emotional%20atmosphere%2C%20film%20poster%20style%2C%20high%20quality%20photography&width=600&height=400&seq=cards-01&orientation=landscape',
  },
  {
    title: '古装玄幻巨制',
    desc: '东方奇幻世界观与精美服化道完美融合，带你领略仙侠世界的磅礴气势与唯美意境。',
    tag: '推荐',
    tagColor: 'accent',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20drama%20scene%20with%20flowing%20robes%20and%20misty%20mountains%2C%20ethereal%20atmosphere%2C%20traditional%20architecture%2C%20soft%20diffused%20lighting%2C%20cinematic%20composition%2C%20warm%20earth%20tones%2C%20epic%20scale&width=600&height=400&seq=cards-02&orientation=landscape',
  },
  {
    title: '悬疑推理专场',
    desc: '烧脑剧情层层反转，高智商对决扣人心弦，每集结尾都让你迫不及待想看下一集。',
    tag: '新番',
    tagColor: 'secondary',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20drama%20atmosphere%20with%20dim%20lighting%20and%20detective%20elements%2C%20film%20noir%20inspired%20style%2C%20dramatic%20shadows%2C%20rainy%20night%20city%20streets%2C%20cinematic%20mood%2C%20muted%20warm%20colors&width=600&height=400&seq=cards-03&orientation=landscape',
  },
  {
    title: '青春校园纯爱',
    desc: '回到最纯真的校园时光，甜蜜又心动的青春故事，每一帧都洋溢着美好与悸动。',
    tag: '甜宠',
    tagColor: 'primary',
    imageUrl: 'https://readdy.ai/api/search-image?query=Youth%20campus%20romance%20drama%20scene%20with%20students%20under%20cherry%20blossoms%2C%20warm%20sunlight%2C%20school%20uniforms%2C%20gentle%20pastel%20tones%2C%20nostalgic%20atmosphere%2C%20soft%20focus%2C%20cinematic%20summer%20vibe&width=600&height=400&seq=cards-04&orientation=landscape',
  },
  {
    title: '经典老剧重温',
    desc: '那些年我们一起追过的经典好剧，历久弥新百看不厌，每一遍重温都有新的感动。',
    tag: '经典',
    tagColor: 'accent',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20classic%20Chinese%20drama%20nostalgic%20scene%20with%20warm%20sepia%20tones%2C%20traditional%20costumes%2C%20emotional%20closeup%20portraits%2C%20soft%20film%20grain%20texture%2C%20timeless%20elegance%2C%20cinematic%20retro%20style&width=600&height=400&seq=cards-05&orientation=landscape',
  },
];

export const indexData = [
  { title: '都市情感', count: 2860, icon: 'ri-heart-line' },
  { title: '古装仙侠', count: 1950, icon: 'ri-moon-line' },
  { title: '悬疑推理', count: 1540, icon: 'ri-search-eye-line' },
  { title: '青春校园', count: 1320, icon: 'ri-sun-line' },
  { title: '家庭伦理', count: 1180, icon: 'ri-home-heart-line' },
  { title: '军旅谍战', count: 960, icon: 'ri-shield-line' },
  { title: '喜剧搞笑', count: 1430, icon: 'ri-emotion-laugh-line' },
];

export const rankingData = [
  { rank: 1, title: '锦绣风华录', hot: '9.6', tag: '古装', change: 'up' },
  { rank: 2, title: '暗夜追踪者', hot: '9.4', tag: '悬疑', change: 'up' },
  { rank: 3, title: '盛夏光年', hot: '9.3', tag: '青春', change: 'new' },
  { rank: 4, title: '职场风云录', hot: '9.1', tag: '都市', change: 'up' },
  { rank: 5, title: '长安十二时辰', hot: '9.0', tag: '古装', change: 'down' },
  { rank: 6, title: '迷雾深处', hot: '8.9', tag: '悬疑', change: 'up' },
  { rank: 7, title: '我家有喜', hot: '8.7', tag: '喜剧', change: 'down' },
];

export const carouselData = [
  {
    title: '暑期档必看清单',
    desc: '这个夏天最不能错过的10部高分好剧，从古装到现代，部部精品任你挑选。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Summer%20drama%20collection%20cinematic%20collage%20with%20golden%20warm%20lighting%2C%20diverse%20Chinese%20drama%20scenes%20blended%20artistically%2C%20film%20strip%20style%2C%20vibrant%20colors%2C%20modern%20design%20composition&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '高分悬疑剧合集',
    desc: '口碑炸裂的烧脑神作，每一部都让你欲罢不能，推理爱好者绝对不能错过。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20drama%20cinematic%20collage%20with%20dramatic%20noir%20lighting%2C%20detective%20elements%2C%20suspenseful%20mood%2C%20contrasted%20shadows%2C%20film%20poster%20aesthetic%2C%20warm%20dark%20tones&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '韩剧精选专区',
    desc: '最新最热韩剧一网打尽，从浪漫爱情到悬疑惊悚，高品质韩剧持续更新中。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20drama%20collection%20cinematic%20collage%20with%20romantic%20and%20dramatic%20scenes%2C%20soft%20pastel%20and%20warm%20lighting%2C%20elegant%20composition%2C%20modern%20aesthetic%2C%20film%20poster%20design%20style&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '年度口碑大剧',
    desc: '豆瓣评分8.5以上的年度佳作，制作精良演技在线，每一部都值得反复品味。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Critically%20acclaimed%20drama%20cinematic%20collage%20with%20award%20worthy%20scenes%2C%20elegant%20composition%2C%20warm%20golden%20and%20earthy%20tones%2C%20premium%20production%20quality%2C%20film%20festival%20poster%20aesthetic&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    title: '甜宠剧场专区',
    desc: '糖分超标的高甜好剧集合，从校服到婚纱，每一段爱情都让你心动不已。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Sweet%20romance%20drama%20cinematic%20collage%20with%20soft%20pink%20and%20warm%20tones%2C%20intimate%20couple%20scenes%2C%20spring%20blossoms%2C%20gentle%20sunlight%2C%20romantic%20film%20poster%20style%2C%20dreamy%20aesthetic&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
];

export const contactData = {
  title: '联系我们',
  desc: '如果你有好的影视资源推荐、合作意向或任何建议，欢迎通过以下方式联系我们。麻花视频期待与你一起打造更好的追剧体验。',
  email: 'contact@mahua.video',
  wechat: 'mahua_video',
};

export const topicsData = [
  { name: '锦绣风华录', count: 128000 },
  { name: '暗夜追踪者', count: 96500 },
  { name: '暑期追剧指南', count: 87300 },
  { name: '古装剧安利', count: 76200 },
  { name: '国产悬疑', count: 68400 },
  { name: '韩剧推荐', count: 59100 },
  { name: '甜宠剧场', count: 53800 },
  { name: '高分好剧', count: 47200 },
  { name: '新剧开播', count: 41500 },
  { name: '经典重温', count: 38900 },
  { name: '都市情感', count: 35200 },
];

export const updatesData = [
  { date: '2026-07-31', title: '《锦绣风华录》大结局今日上线，全集48集一次性解锁', tag: '热播' },
  { date: '2026-07-30', title: '悬疑新剧《暗夜追踪者》开播即爆，首日播放量突破5000万', tag: '新剧' },
  { date: '2026-07-28', title: '平台全面升级CDN节点，播放流畅度提升40%', tag: '公告' },
  { date: '2026-07-25', title: '暑期档专题页面上线，百部高分好剧一网打尽', tag: '专题' },
  { date: '2026-07-22', title: '麻花视频App更新至v3.2版本，新增智能推荐算法', tag: '更新' },
  { date: '2026-07-19', title: '韩剧专区新增12部热播韩剧，中文字幕同步更新', tag: '上新' },
  { date: '2026-07-15', title: '与三大版权方达成深度合作，正版片库再扩容', tag: '公告' },
  { date: '2026-07-10', title: '青春校园剧《盛夏光年》豆瓣开分9.2，口碑持续走高', tag: '热播' },
];

export const faqData = [
  {
    q: '麻花视频需要付费或注册会员吗？',
    a: '完全不需要！麻花视频坚持免费观影理念，所有内容面向全网用户开放，无需注册账号，无需购买会员，打开网站即可直接观看高清电视剧和电影。',
  },
  {
    q: '为什么有些剧集播放时会缓冲？',
    a: '平台采用多线路智能切换技术，建议在播放器右下角手动切换备用线路。如果仍遇到缓冲问题，可能是当前时段用户较多，建议稍后重试或切换清晰度。正常情况下1080P也能流畅播放。',
  },
  {
    q: '新剧上线后多久能在麻花视频看到？',
    a: '热门剧集通常在电视台播出后24小时内同步更新，部分热门剧集可实现当天更新。每日更新时间为上午10点和晚上8点两个时段，关注首页更新动态不错过任何好剧。',
  },
  {
    q: '麻花视频支持哪些设备观看？',
    a: '平台全面支持PC端、手机浏览器、平板等设备在线观看。同时提供Android和iOS客户端下载，App端支持离线缓存、画中画播放等便捷功能，随时随地追剧更自由。',
  },
];

export const appData = {
  title: '随时随地 · 追剧无忧',
  desc: '下载麻花视频App，畅享离线缓存、画中画播放、智能推荐等独家功能，地铁通勤、午休时间都能轻松追剧。',
  features: ['离线缓存', '画中画', '智能推荐', '夜间模式', '倍速播放'],
};

export const mediaData = [
  {
    title: '锦绣风华录 · 精彩片花',
    desc: '古装巨制震撼来袭，顶级制作阵容打造年度最美古装剧',
    duration: '03:25',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20drama%20highlight%20scene%20with%20elaborate%20robes%20and%20palace%20interior%2C%20cinematic%20golden%20lighting%2C%20dramatic%20composition%2C%20warm%20amber%20tones%2C%20film%20poster%20quality%2C%20epic%20scale&width=600&height=340&seq=media-01&orientation=landscape',
  },
  {
    title: '暗夜追踪者 · 预告片',
    desc: '高智商犯罪悬疑剧，反转不断烧脑升级，全程高能无尿点',
    duration: '02:18',
    imageUrl: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20drama%20scene%20with%20detective%20in%20dark%20alley%2C%20neon%20reflections%20on%20wet%20pavement%2C%20noir%20cinematic%20lighting%2C%20suspenseful%20atmosphere%2C%20film%20poster%20aesthetic%2C%20warm%20contrast%20tones&width=600&height=340&seq=media-02&orientation=landscape',
  },
  {
    title: '盛夏光年 · 心动瞬间',
    desc: '青春校园甜宠剧，记录最美好的年少时光，温暖治愈每一颗心',
    duration: '04:10',
    imageUrl: 'https://readdy.ai/api/search-image?query=Youth%20campus%20romance%20drama%20sunny%20scene%20with%20students%20laughing%20on%20school%20field%2C%20soft%20golden%20hour%20lighting%2C%20warm%20nostalgic%20tones%2C%20gentle%20bokeh%2C%20film%20poster%20quality%2C%20summer%20vibes&width=600&height=340&seq=media-03&orientation=landscape',
  },
  {
    title: '职场风云录 · 高光片段',
    desc: '聚焦当代职场生态，真实又不失温度的职场群像剧，引发无数共鸣',
    duration: '05:02',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20office%20drama%20scene%20with%20professionals%20in%20contemporary%20workspace%2C%20natural%20sunlight%20through%20large%20windows%2C%20warm%20neutral%20colors%2C%20cinematic%20composition%2C%20film%20poster%20style%2C%20polished%20aesthetic&width=600&height=340&seq=media-04&orientation=landscape',
  },
];

export const commentsData = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20young%20Chinese%20woman%20with%20warm%20smile%2C%20simple%20clean%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '追剧小达人',
    time: '2小时前',
    content: '麻花视频真的太良心了！画质清晰又不卡顿，关键是完全免费，已经推荐给身边所有追剧的朋友了。',
    likes: 326,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20Chinese%20man%20with%20gentle%20expression%2C%20simple%20clean%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '悬疑剧重度患者',
    time: '5小时前',
    content: '《暗夜追踪者》太好看了！每集结尾都留悬念，根本停不下来，希望麻花视频能多引进这类高质量悬疑剧。',
    likes: 218,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20young%20Chinese%20woman%20with%20bright%20eyes%2C%20simple%20clean%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '夏日柠檬茶',
    time: '昨天 18:30',
    content: '每天下班回家打开麻花视频追两集剧已经成了习惯，1080P的画质在大屏上看特别过瘾，更新速度也超快！',
    likes: 157,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20Chinese%20man%20with%20friendly%20smile%2C%20simple%20clean%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '剧荒拯救者',
    time: '昨天 10:15',
    content: '分类索引功能太好用了！之前总是剧荒不知道看什么，现在按照类型一搜就有好多高分推荐，妈妈再也不用担心我没剧看了。',
    likes: 203,
  },
];

export const footerLinks = {
  about: [
    { name: '关于我们', href: '#about' },
    { name: '联系我们', href: '#contact' },
    { name: '常见问答', href: '#faq' },
  ],
  content: [
    { name: '热播榜单', href: '#ranking' },
    { name: '焦点专题', href: '#carousel' },
    { name: '最新动态', href: '#updates' },
  ],
  partner: [],
};